const _temp0 = require("url:../../public/example/CEG_flowChart.svg");
const _temp1 = require("url:../../public/example/CERA_flowChart.svg");
const _temp2 = require("url:../../public/example/CT_flowChart.svg");
const _temp3 = require("url:../../public/example/QEG_flowChart.svg");
module.exports = {
  "CEG_flowChart": _temp0,
  "CERA_flowChart": _temp1,
  "CT_flowChart": _temp2,
  "QEG_flowChart": _temp3
}